export interface Usuario {
  codusu: number;
  apelid: string;
  nomusu: string;
}

const TOKEN_KEY = "formsteel-token";
const USER_KEY = "formsteel-user";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function getUsuario(): Usuario | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Usuario;
  } catch {
    return null;
  }
}

export function setUsuario(u: Usuario) {
  localStorage.setItem(USER_KEY, JSON.stringify(u));
}

export async function login(apelid: string, senha: string): Promise<Usuario> {
  const r = await fetch("/api/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ apelid, senha }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({ error: `HTTP ${r.status}` }));
    throw new Error(body.error ?? "erro no login");
  }
  const data = (await r.json()) as { token: string; usuario: Usuario };
  setToken(data.token);
  setUsuario(data.usuario);
  return data.usuario;
}

export function logout() {
  clearToken();
  window.location.reload();
}
